import { LifeRingTrigger } from 'components/ActionBar/LifeRing/LifeRingButton/LifeRingButton';
import { ConnectedHelpCenterButton } from 'components/shared/HelpCenter/HelpCenterButton';
import { FormattedMessage } from 'components/shared/Intl/FormattedMessage';
import { useToggleFeature } from 'hooks/useToggleFeature';

export function ProductSelectorEmptyState() {
  const helpCenterEnhancement = useToggleFeature('helpCenterEnhancement');

  return (
    <div className="d-flex flex-column justify-content-center align-items-center w-100 bg-lvl2 px-5">
      <span className="icon icon-outlined icon-lg text-secondary">view_week</span>
      <h3 className="text-secondary text-center mb-1">
        <FormattedMessage id="productSelector.available.products.notFound" />
      </h3>
      <p className="text-center text-secondary mb-4">
        <FormattedMessage id="productSelector.available.products.notFound.description" />
      </p>
      {helpCenterEnhancement ? (
        <ConnectedHelpCenterButton helpCenterId={ProductSelectorEmptyState.name} />
      ) : (
        <LifeRingTrigger e2e="ProductSelectorContactUs-button">
          <button type="button" className="btn btn-discreet-secondary btn-icon-end">
            <FormattedMessage id="lifeRing.helpRequest" />
            <em className="icon icon-outlined">live_help</em>
          </button>
        </LifeRingTrigger>
      )}
    </div>
  );
}
